//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data() {
    return {
      init: false,
      loading: false,
      showDialog: this.show,
      form: {
        webName: '',
        webDesc: '',
        deviceType: '',
        webString: '',
        id: '',
      },
      rules: {
        webName: [{ required: true, message: '请输入页面名称', trigger: 'blur' }],
        webDesc: [{ required: false, message: '', trigger: 'blur' }],
        deviceType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      },
      deviceTypeList: [],
      isAble: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    show: function (value) {
      if(this.$refs['form']) this.$refs['form'].resetFields()
      this.showDialog = value
    },
  },
  computed: mapState([
    'componentData',
    'canvasStyleData',
  ]),
  created(){
    var id = this.$route.query.I
    var webName = this.$route.query.N
    var deviceType = Number(this.$route.query.T)
    var webDesc = this.$route.query.D
    if(id) {
      this.form.id = id
      this.form.webName = webName
      this.form.deviceType = deviceType
      this.form.webDesc = webDesc
      this.isAble = true
    } else {
      this.form.id = ''
      this.form.webName = ''
      this.form.deviceType = ''
      this.form.webDesc = ''
      this.isAble = false
    }
    this.getDeviceType()
  },
  methods: {
    closeDialog() {
      this.$emit('editReceive',{
        key: 'showEdit',
        value: this.showDialog
      })
    },
    onSubmit(formName) {
      let base = this
      var flag = true

      base.$refs[formName].validate((valid) => {
        if (!valid) {
          flag = false
          return false
        }
      })
      if(flag) {
        base.doCreate()
      }
    },
    doCreate() {
      let base = this
      base.loading = true
      base.form.webString = JSON.stringify(JSON.stringify(this.componentData))
      let str = JSON.stringify(this.componentData)
      if(str.indexOf('"publish":true') == -1 && str.indexOf('"subscribe":true') == -1) {
        this.$message({
          message: '请至少为一个组件绑定事件！',
          type: 'error',
          duration: 3 * 1000
        })
        return
      }
      base.request({
        url: '/web/save',
        method: 'post',
        data: base.form
      }).then(response => {
        base.loading = false
        base.showDialog = false
        localStorage.setItem('canvasData', JSON.stringify(JSON.stringify(this.componentData)))
        base.$message({
          message: '保存成功',
          type: 'success',
          duration: 3 * 1000,
        })
        window.close()
      }).catch(error => {
        base.loading = false
        base.$message({
          message: error.errmsg,
          type: 'error',
          duration: 3 * 1000
        })
      })
    },
    getDeviceType() {
      this.request({
        url: '/web/type/page',
        method: 'post',
        data: {}
      }).then(response => {
        this.deviceTypeList = response.rows
      }).catch(error => {
        this.$message({
          message: error.errmsg == '令牌不能为空' ? '登录信息异常，请重新登录' : error.errmsg,
          type: 'error',
          duration: 3 * 1000
        })
      })
    },
  }
}
